function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinanceMoneyCashStack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "finance_x5F_money_x5F_cash_x5F_stack",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 30",
    style: {
      enableBackground: "new 0 0 32 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M32,18H0V0h32V18z M2,16h28V2H2V16z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M6,17H4c0-1.654-1.346-3-3-3v-2C3.757,12,6,14.243,6,17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M1,6V4c1.654,0,3-1.346,3-3h2C6,3.757,3.757,6,1,6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M31,6c-2.757,0-5-2.243-5-5h2c0,1.654,1.346,3,3,3V6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M28,17h-2c0-2.757,2.243-5,5-5v2C29.346,14,28,15.346,28,17z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD5C3F"
    },
    d: "M16,13c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S18.206,13,16,13z M16,7c-1.103,0-2,0.897-2,2 s0.897,2,2,2s2-0.897,2-2S17.103,7,16,7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 8,
    style: {
      fill: "#FD5C3F"
    },
    width: 4,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8,
    style: {
      fill: "#FD5C3F"
    },
    width: 4,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 20,
    style: {
      fill: "#FD5C3F"
    },
    width: 32,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 24,
    style: {
      fill: "#FD5C3F"
    },
    width: 32,
    height: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 28,
    style: {
      fill: "#FD5C3F"
    },
    width: 32,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceMoneyCashStack);
export default __webpack_public_path__ + "static/media/finance_money_cash_stack.ad93bbb561d9eab24a1df1e21595cbe6.svg";
export { ForwardRef as ReactComponent };